/**
 * Fonction pour remplacer les images SVG des étapes morphologiques en fonction de l'IMC
 */
(function() {
  'use strict';
  
  // Catalogue des images SVG
  const imageUrls = {
    // Étape 2 - Ventre (stomach)
    'stomach': {
      'ecto': {
        'flat': 'https://cdn.shopify.com/s/files/1/0660/8096/4856/files/female-ecto-stomach-flatter.svg?v=1747482491',
        'average': 'https://cdn.shopify.com/s/files/1/0660/8096/4856/files/female-ecto-stomach-average.svg?v=1747482490',
        'round': 'https://cdn.shopify.com/s/files/1/0660/8096/4856/files/female-ecto-stomach-rounder.svg?v=1747482492'
      },
      'meso': {
        'flat': 'https://cdn.shopify.com/s/files/1/0660/8096/4856/files/female-meso-stomach-flatter.svg?v=1747482491',
        'average': 'https://cdn.shopify.com/s/files/1/0660/8096/4856/files/female-meso-stomach-average.svg?v=1747482490',
        'round': 'https://cdn.shopify.com/s/files/1/0660/8096/4856/files/female-meso-stomach-rounder.svg?v=1747482490'
      },
      'endo': {
        'flat': 'https://cdn.shopify.com/s/files/1/0660/8096/4856/files/female-endo-stomach-flatter.svg?v=1747482490',
        'average': 'https://cdn.shopify.com/s/files/1/0660/8096/4856/files/female-endo-stomach-average.svg?v=1747482491',
        'round': 'https://cdn.shopify.com/s/files/1/0660/8096/4856/files/female-endo-stomach-rounder.svg?v=1747482491'
      }
    },
    
    // Étape 3 - Hanches (hips)
    'hips': {
      'ecto': {
        'narrow': 'https://cdn.shopify.com/s/files/1/0660/8096/4856/files/female-ecto-hips-narrower.svg?v=1747482491',
        'average': 'https://cdn.shopify.com/s/files/1/0660/8096/4856/files/female-ecto-hips-average.svg?v=1747482491',
        'curved': 'https://cdn.shopify.com/s/files/1/0660/8096/4856/files/female-ecto-hips-broader.svg?v=1747482490'
      },
      'endo': {
        'narrow': 'https://cdn.shopify.com/s/files/1/0660/8096/4856/files/female-endo-hips-narrower.svg?v=1747482491',
        'average': 'https://cdn.shopify.com/s/files/1/0660/8096/4856/files/female-endo-hips-average.svg?v=1747482491',
        'curved': 'https://cdn.shopify.com/s/files/1/0660/8096/4856/files/female-endo-hips-broader.svg?v=1747482491'
      }
    },
    
    // Étape 4 - Fesses (seat)
    'seat': {
      'flat': 'https://cdn.shopify.com/s/files/1/0660/8096/4856/files/female-ecto-seat-flatter.svg?v=1747482491',
      'average': 'https://cdn.shopify.com/s/files/1/0660/8096/4856/files/female-ecto-seat-average.svg?v=1747482490',
      'round': 'https://cdn.shopify.com/s/files/1/0660/8096/4856/files/female-ecto-seat-rounder.svg?v=1747482490'
    }
  };
  
  // Fonction pour calculer l'IMC à partir des données saisies
  function calculateBMI() {
    const heightInput = document.getElementById('naked-size-height');
    const weightInput = document.getElementById('naked-size-weight');
    
    if (!heightInput || !weightInput || !heightInput.value || !weightInput.value) {
      return null; // Données incomplètes
    }
    
    let height = parseFloat(heightInput.value);
    let weight = parseFloat(weightInput.value);
    
    // Convertir si en unités impériales
    const unitButtons = document.querySelectorAll('.naked-size-unit');
    let isMetric = true;
    
    unitButtons.forEach(button => {
      if (button.classList.contains('active')) {
        if (button.getAttribute('data-unit') === 'feet') {
          isMetric = false;
        }
        if (button.getAttribute('data-unit') === 'lbs') {
          isMetric = false;
        }
      }
    });
    
    // Conversion en unités métriques si nécessaire
    if (!isMetric) {
      // Pieds en mètres
      height = height * 0.3048;
      // Livres en kg
      weight = weight * 0.453592;
    } else {
      // Conversion cm en mètres
      height = height / 100;
    }
    
    // Calcul de l'IMC
    const bmi = weight / (height * height);
    
    return bmi;
  }
  
  // Fonction pour déterminer le type morphologique en fonction de l'IMC
  function getMorphType(bmi, category) {
    if (category === 'stomach') {
      if (bmi < 21.5) return 'ecto';
      if (bmi <= 26.5) return 'meso';
      return 'endo';
    } else if (category === 'hips') {
      if (bmi < 22) return 'ecto';
      return 'endo';
    }
    
    // Pour les fesses, pas de différenciation par IMC
    return null;
  }
  
  // Fonction pour remplacer les images
  function updateMorphologyImages() {
    const bmi = calculateBMI();
    
    if (bmi === null) {
      // Si l'IMC n'est pas encore calculable, attendre
      console.log('IMC non calculable, données insuffisantes');
      return;
    }
    
    console.log('IMC calculé:', bmi);
    
    // Étape 2 - Ventre
    const stomachType = getMorphType(bmi, 'stomach');
    document.querySelectorAll('.naked-size-step[data-step="2"] .naked-size-morphology-option').forEach(option => {
      const value = option.getAttribute('data-value');
      const imageContainer = option.querySelector('.naked-size-morphology-image');
      
      if (imageContainer) {
        // Si c'est un type avec différenciation par IMC
        if (stomachType && imageUrls.stomach[stomachType] && imageUrls.stomach[stomachType][value]) {
          imageContainer.innerHTML = `<img src="${imageUrls.stomach[stomachType][value]}" alt="${value}" width="80" height="80">`;
        }
      }
    });
    
    // Étape 3 - Hanches
    const hipsType = getMorphType(bmi, 'hips');
    document.querySelectorAll('.naked-size-step[data-step="3"] .naked-size-morphology-option').forEach(option => {
      const value = option.getAttribute('data-value');
      const imageContainer = option.querySelector('.naked-size-morphology-image');
      
      if (imageContainer) {
        // Si c'est un type avec différenciation par IMC
        if (hipsType && imageUrls.hips[hipsType] && imageUrls.hips[hipsType][value]) {
          imageContainer.innerHTML = `<img src="${imageUrls.hips[hipsType][value]}" alt="${value}" width="80" height="80">`;
        }
      }
    });
    
    // Étape 4 - Fesses (pas de différenciation par IMC)
    document.querySelectorAll('.naked-size-step[data-step="4"] .naked-size-morphology-option').forEach(option => {
      const value = option.getAttribute('data-value');
      const imageContainer = option.querySelector('.naked-size-morphology-image');
      
      if (imageContainer && imageUrls.seat[value]) {
        imageContainer.innerHTML = `<img src="${imageUrls.seat[value]}" alt="${value}" width="80" height="80">`;
      }
    });
  }
  
  // Fonction de mise à jour après chaque saisie dans les champs
  function setupInputListeners() {
    const heightInput = document.getElementById('naked-size-height');
    const weightInput = document.getElementById('naked-size-weight');
    
    if (heightInput && weightInput) {
      heightInput.addEventListener('input', updateMorphologyImages);
      weightInput.addEventListener('input', updateMorphologyImages);
      
      // Écouter aussi les changements d'unités
      document.querySelectorAll('.naked-size-unit').forEach(unit => {
        unit.addEventListener('click', updateMorphologyImages);
      });
    }
  }
  
  // Initialisation
  function init() {
    // Attendre que le widget soit chargé
    if (document.querySelector('.naked-size-step[data-step="1"]')) {
      setupInputListeners();
    } else {
      // Réessayer plus tard
      setTimeout(init, 500);
    }
  }
  
  // Lancer l'initialisation au chargement du DOM
  document.addEventListener('DOMContentLoaded', init);
  
  // S'assurer que les événements sont correctement liés après le chargement complet
  window.addEventListener('load', function() {
    setTimeout(init, 800);
  });
})();